
import Model from '@/models/Model'

export default class AccAccountType extends Model {
    resource() {
        return 'acc_account_type'
    }    

    /**
     * 
     */
    get code_clean() {
        return this.code.split('.').join('')
    }

    /**
     * 
     */
    get code_int() {
        return parseInt(this.code_clean)
    }
}